import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", href: "/" },
  { label: "女优分类", href: "/category" },
  { label: "影视作品", href: "/work-list" },
  { label: "新闻动态", href: "/news" },
  { label: "关于本站", href: "/about" },
];

const hotLinks = [
  { label: "绫濑真央", href: "/detail/actress/a01" },
  { label: "神宫寺葵", href: "/detail/actress/a05" },
  { label: "白夜的花火", href: "/detail/work/w17" },
  { label: "东京的四个季节", href: "/detail/work/w03" },
  { label: "静默的证词", href: "/detail/work/w14" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-8">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-foreground-950">
                日
              </span>
              <span className="font-heading text-lg font-black tracking-wide text-background-50">日本女优</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
              面向日本影视爱好者与研究者的资料索引站，系统整理女优档案、影视作品与行业新闻，坚持信息清晰、检索高效、阅读舒适。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="https://91ggwang.asia"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X 社交平台"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-background-100/25 text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-twitter-x-line" aria-hidden="true"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-background-100/25 text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-instagram-line" aria-hidden="true"></i>
              </a>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="flex h-8 w-8 items-center justify-center rounded-full border border-background-100/25 text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                <i className="ri-youtube-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-label text-xs tracking-[0.16em] text-accent-300">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="font-label text-sm text-background-100/75 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-xs tracking-[0.16em] text-accent-300">热门条目</h3>
            <ul className="mt-4 space-y-2.5">
              {hotLinks.map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="font-label text-sm text-background-100/75 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-xs tracking-[0.16em] text-accent-300">联系与反馈</h3>
            <ul className="mt-4 space-y-3 font-label text-sm text-background-100/75">
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </span>
                <a href="mailto:archive@japan-actress.example" className="transition-colors hover:text-accent-300">
                  archive@japan-actress.example
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-map-pin-line" aria-hidden="true"></i>
                </span>
                <span>东京都涩谷区 · 资料编辑室</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
                  <i className="ri-time-line" aria-hidden="true"></i>
                </span>
                <span>资料更新：每周三 · 10:00-18:00</span>
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1 rounded-md border border-background-100/25 px-3 py-1.5 font-label text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
            >
              查看反馈入口
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full max-w-[1180px] flex-col gap-2 px-4 py-5 font-label text-[11px] text-background-100/55 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 日本女优 · 资料索引站。本站为示例资料展示站点，内容仅供索引与学术研究参考。</p>
          <p>本站不提供视频播放、下载或任何交易服务。</p>
        </div>
      </div>
    </footer>
  );
}